import { render, staticRenderFns } from "./ApplicantLogsComponent.vue?vue&type=template&id=6a9c91a9&"
import script from "./ApplicantLogsComponent.vue?vue&type=script&lang=ts&"
export * from "./ApplicantLogsComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a9c91a9')) {
      api.createRecord('6a9c91a9', component.options)
    } else {
      api.reload('6a9c91a9', component.options)
    }
    module.hot.accept("./ApplicantLogsComponent.vue?vue&type=template&id=6a9c91a9&", function () {
      api.rerender('6a9c91a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Applicant/ApplicantLogsComponent.vue"
export default component.exports